module.exports = __webpack_public_path__ + "static/media/pic1.e70bddf4.jpg";